import { EsquireClient } from "@/types/clients/esquire";
import PostVatNumberPayload from "@/types/clients/esquire/payloads/post-vat-number-payload";
import VatNumber from "@/types/clients/esquire/data/vat-number";

export type VatNumberStoreResult = {
  status: number;
  message?: string;
  code?: string;
  viesCode?: string;
  vat?: VatNumber;
};

export default class PostVatNumberRequest {
  constructor(private client: EsquireClient) {}

  public async send(payload: PostVatNumberPayload): Promise<VatNumberStoreResult> {
    const url = await this.client.fetchUrlFromSession("vat-number-store");

    const response = await this.client.fetch(
      () => new URL(url),
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload.toJsonObject())
      }
    );

    await this.client.logOutIfForbidden(response.status);
    const body = await response.json();

    if (!response.ok) {
      return {
        status: response.status,
        message: body?.message,
        code: body?.code,
        viesCode: body?.errors?.vies_code
      };
    }

    const raw = body?.data ?? body;
    return {
      status: response.status,
      message: body?.message,
      vat: VatNumber.fromJson(raw)
    };
  }
}
